import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  appPageTableHeader: {
    position: "sticky",
    top: theme.heightDesktopHeader,
    flex: "0 1 auto",
    zIndex: theme.zIndex.app.logo
  }
}));
